import { render, staticRenderFns } from "./OrderProfileCard.vue?vue&type=template&id=fcc070c6&scoped=true&"
import script from "./OrderProfileCard.vue?vue&type=script&lang=js&"
export * from "./OrderProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc070c6",
  null
  
)

export default component.exports